import qs from 'qs'
import axios from "axios";
import VueAxios from 'vue-axios'
import camelcaseKeys from 'camelcase-keys';
import cloneDeep from 'lodash.clonedeep';
const BASE_URL = process.env.VUE_APP_BASEURL



const instance = axios.create({
    baseURL: BASE_URL,
    paramsSerializer: (params) => {
        return qs.stringify(params, {
            arrayFormat: 'brackets'
        })
    }
});

export {
    instance
}

export default {
    install(app,
        options) {
        const store = options.store;

        instance.interceptors.request.use(req => {
            const token = store.getters.GET_TOKEN;
            if (token) {
                req.headers.Authorization = `Bearer ${token}`
            }
            if (req.method === 'post') {
                if (req.url == '/chat/message') {
                    // delete req.data.socket_id;
                }
                if (req.data instanceof FormData) {
                    // instance.defaults.headers.post['Content-Type'] = 'multipart/form-data';
                    req.headers['Content-Type'] = 'multipart/form-data'
                } else {
                    req.headers['Content-Type'] = 'application/x-www-form-urlencoded'
                    req.data = qs.stringify(req.data)
                }
            }
            return req
        })

        instance.interceptors.response.use(resp => {
            // if (resp.config.url != '/chat/counters') {
            // }
            try {
                if (resp.data && resp.headers['content-type'].includes('application/json') && resp.config.url != '/list/languages') {
                    const url = resp.config.url || '';
                    const isJobsDetail = url.includes('/jobs-detail/');
                    const isJobShiftsList = /\/jobs\/[^/?]+\/shifts/.test(url);

                    if (isJobsDetail || isJobShiftsList) {
                        // Preserve more_option_internal_pools keys/structure — deep camelCase breaks pool-id maps.
                        const originalShifts = isJobsDetail
                            ? (resp.data.data?.shifts || [])
                            : (Array.isArray(resp.data?.data) ? resp.data.data : []);
                        const originalInternalPools = originalShifts.map(
                            (shift) => shift?.visibilities?.more_option_internal_pools || null
                        );

                        if (isJobsDetail) {
                            resp.data.data = camelcaseKeys(resp.data.data, { deep: true });
                            originalInternalPools.forEach((pools, index) => {
                                if (pools && resp.data.data.shifts?.[index]?.visibilities) {
                                    resp.data.data.shifts[index].visibilities.moreOptionInternalPools =
                                        cloneDeep(pools);
                                }
                            });
                        } else {
                            resp.data = camelcaseKeys(resp.data, { deep: true });
                            originalInternalPools.forEach((pools, index) => {
                                if (pools && resp.data.data?.[index]?.visibilities) {
                                    resp.data.data[index].visibilities.moreOptionInternalPools =
                                        cloneDeep(pools);
                                }
                            });
                        }
                    } else {
                        // For all other URLs, convert all keys deeply
                        resp.data = camelcaseKeys(resp.data, {
                            deep: true
                        })
                    }

                }
            } catch (error) {
                throw Error(
                    `[requestClient] Error parsingJSON data - ${JSON.stringify(
                        error
                    )}`
                );
            }

            return resp
        }, function (error) {
            if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
            } else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                // http.ClientRequest in node.js
                console.log(error.request);
            } else {
                // Something happened in setting up the request that triggered an Error
                console.log('Error', error.message);
            }
            if (error.response.status === 401) {
                return new Promise(() => {
                    console.log(error.response);
                    store.dispatch('AUTH_REMOVE_TOKEN');
                    throw error;
                });
            }
            throw error;
        });
        app.use(VueAxios, instance);

    }

};
// export default instance